import { isEmpty } from 'lodash';
import CONSTANTS from '../constants/constant';

export default class User {
  constructor(initData?: any) {
    if (initData) {
      Object.assign(this, initData);
    }
  }

  id: number = 0;
  email: string = '';
  token: string = '';
  // MÃ ĐĂNG NHẬP APP: 8 chữ số, backend sinh khi đăng nhập, trả về qua /auth/profile,
  // hiển thị trên header. Rỗng khi chưa đăng nhập hoặc sau khi đăng xuất.
  app_login_code: string = '';
  role: string = '';
  system_roles: string[] = [];
  chat_roles: string[] = [];
  staff_roles: string[] = [];
  app_roles: string[] = [];
  ppkd_roles: string[] = [];
  management_roles: string[] = [];
  insurance_roles: string[] = [];
  secretary_roles: string[] = [];
  regulation_roles_2: string[] = [];
  salary_roles_2: string[] = [];
  payment_roles: string[] = [];
  collateral_roles: string[] = [];
  ksd_roles: string[] = [];
  bank_statistic_roles: string[] = [];
  phan_loai_nhom_nganh_roles: string[] = [];
  execute_plan_admin_roles: string[] = [];
  danh_gia_vic_ai_roles: string[] = [];
  lich_lam_viec_roles: string[] = [];
  execute_the_plan_roles: string[] = [];
  ke_toan_chung_tu_roles: string[] = [];
  nganh_phu_tro_roles: string[] = [];
  created_at: string = '';
  full_name: string = '';
  contact: string = '';
  address: string = '';
  password: string = '';
  raw_password: string = '';
  secondary_password: string = '';
  third_password: string = '';
  avatar: string = '';
  projects: string[] = [];
  vic_menus: string[] = [];
  po_menus: string[] = [];
  po_ip_address: string = '';
  po_tai_xe_roles: string[] = [];
  po_don_hang_tai_xe_roles: string[] = [];
  po_lich_trinh_tai_xe_roles: string[] = [];
  po_ds_kh_roles: string[] = [];
  po_don_hang_kh_roles: string[] = [];
  po_van_hanh_roles: string[] = [];
  has_payment_permission_1: boolean = false;
  has_payment_permission_2: boolean = false;
  has_payment_permission_3: boolean = false;
  has_payment_permission_4: boolean = false;
  manager3_users: number[] = [];
  // NEW payment-permission feature (TTCK). Flat list of granted permission codes
  // ("<group_code>:<action_code>") for the user's position, resolved by the
  // backend from the PaymentPermissionSetting matrix. Read via useQuyenTtck().
  quyen_ttck: string[] = [];
  // Chức vụ (users.position = permission_roles.name), vd 'KẾ TOÁN KIỂM SOÁT'.
  position: string = '';
  // VIC APP MENU: quyền hiển thị menu VIC Chat Desktop theo user ({key: bool},
  // thiếu key = true). Admin bật/tắt trong AddUserWebDialog (mục VIC APP MENU).
  vic_app_menu: { [key: string]: boolean } = {};
  message: string = '';
  
  isLoggedIn(): boolean {
    return !isEmpty(this.token);
  }

  isAdmin(): boolean {
    try {
      return this.system_roles.indexOf(CONSTANTS.SYSTEM_ROLES.QUAN_TRI_HE_THONG) >= 0;
    } catch (e) {
      return false;
    }
  }

  hasRole(role: string): boolean {
    try {
      return (
        this.isAdmin() ||
        this.system_roles.indexOf(role) >= 0 ||
        this.chat_roles.indexOf(role) >= 0 ||
        this.staff_roles.indexOf(role) >= 0 ||
        this.app_roles.indexOf(role) >= 0 ||
        this.ppkd_roles.indexOf(role) >= 0 ||
        this.management_roles.indexOf(role) >= 0 ||
        this.insurance_roles.indexOf(role) >= 0 ||
        this.secretary_roles.indexOf(role) >= 0 ||
        this.regulation_roles_2.indexOf(role) >= 0 ||
        this.salary_roles_2.indexOf(role) >= 0 ||
        this.payment_roles.indexOf(role) >= 0 ||
        this.collateral_roles.indexOf(role) >= 0 ||
        this.ksd_roles.indexOf(role) >= 0 ||
        this.bank_statistic_roles.indexOf(role) >= 0 ||
        this.phan_loai_nhom_nganh_roles.indexOf(role) >= 0 ||
        this.execute_plan_admin_roles.indexOf(role) >= 0 ||
        this.ke_toan_chung_tu_roles.indexOf(role) >= 0 ||
        this.danh_gia_vic_ai_roles.indexOf(role) >= 0 ||
        this.lich_lam_viec_roles.indexOf(role) >= 0
      );
    } catch (e) {
      return false;
    }
  }

  hasProject(project: string): boolean {
    try {
      return this.projects.indexOf(project) >= 0;
    } catch (e) {
      return false;
    }
  }

  hasVicMenu(menu: string): boolean {
    try {
      return this.vic_menus.indexOf(menu) >= 0;
    } catch (e) {
      return false;
    }
  }

  hasPOMenu(menu: string): boolean {
    try {
      return this.po_menus.indexOf(menu) >= 0;
    } catch (e) {
      return false;
    }
  }

  hasSystemRole(role: string): boolean {
    return this.system_roles?.indexOf(role) >= 0;
  }

  hasPaymentRole(role: string): boolean {
    return this.payment_roles?.indexOf(role) >= 0;
  }

  // NEW TTCK feature. Check a single permission code ("<group_code>:<action>").
  hasQuyenTtck(code: string): boolean {
    return this.quyen_ttck?.indexOf(code) >= 0;
  }

  // Check a TTCK action on a group, e.g. canQuyenTtck('...lenh_thanh_toan_chuyen_khoan', 'create').
  canQuyenTtck(groupCode: string, action: string): boolean {
    return this.hasQuyenTtck(`${groupCode}:${action}`);
  }

  hasBankStatisticRole(role: string): boolean {
    return this.bank_statistic_roles?.indexOf(role) >= 0;
  }

  hasPhanLoaiNhomNganhRole(role: string): boolean {
    return this.phan_loai_nhom_nganh_roles?.indexOf(role) >= 0;
  }

  hasExecutePlanAdminRole(role: string): boolean {
    return this.execute_plan_admin_roles?.indexOf(role) >= 0;
  }

  hasKeToanChungTuRole(role: string): boolean {
    return this.ke_toan_chung_tu_roles?.indexOf(role) >= 0;
  }

  hasDanhGiaVicAiRole(role: string): boolean {
    return this.danh_gia_vic_ai_roles?.indexOf(role) >= 0;
  }

  hasLichLamViecRole(role: string): boolean {
    return this.lich_lam_viec_roles?.indexOf(role) >= 0;
  }

  hasExecutePlanRole(role: string): boolean {
    return this.execute_the_plan_roles?.indexOf(role) >= 0;
  }

  hasNganhPhuTroRole(role: string): boolean {
    return this.nganh_phu_tro_roles?.indexOf(role) >= 0;
  }

  hasCollateralRole(role: string): boolean {
    return this.collateral_roles?.indexOf(role) >= 0;
  }

  hasSalaryRole(): boolean {
    return this.isAdmin() || this.salary_roles_2.length > 0;
  }

  hasProjectOneRole(role: string): boolean {
    return (
      this.po_tai_xe_roles?.indexOf(role) >= 0 ||
      this.po_don_hang_tai_xe_roles?.indexOf(role) >= 0 ||
      this.po_lich_trinh_tai_xe_roles?.indexOf(role) >= 0 ||
      this.po_ds_kh_roles?.indexOf(role) >= 0 ||
      this.po_don_hang_kh_roles?.indexOf(role) >= 0 ||
      this.po_van_hanh_roles?.indexOf(role) >= 0
    );
  }

  hasPaymentApprovalRole(role: string): boolean {
    if (role === CONSTANTS.PAYMENT_ROLES.QUAN_LY_THANH_TOAN_1) {
      return this.has_payment_permission_1;
    } else if (role === CONSTANTS.PAYMENT_ROLES.QUAN_LY_THANH_TOAN_2) {
      return this.has_payment_permission_2;
    } else if (role === CONSTANTS.PAYMENT_ROLES.QUAN_LY_THANH_TOAN_3) {
      return this.has_payment_permission_3;
    } else if (role === CONSTANTS.PAYMENT_ROLES.QUAN_LY_THANH_TOAN_4) {
      return this.has_payment_permission_4;
    }
    return false;
  }
}
